import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=ac45d97a&scoped=true&"
import script from "./SideMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuItem.vue?vue&type=style&index=0&id=ac45d97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac45d97a",
  null
  
)

component.options.__file = "SideMenuItem.vue"
export default component.exports